import LastOrganisationId from './LastOrganisationId';
import Token from '../../../packages/extension/src/background/Token';

export default function logout() {
    return new Promise((resolve, reject) => {
        Token.remove();
        LastOrganisationId.clear();
        resolve();
    });
}
